import React from 'react';
import propTypes from 'prop-types';
import styled, { css } from 'styled-components';

import {
  white,
  PrimaryDark,
  smokeGray,
  translucentGray,
  PrimaryMedium,
} from '../../../../cra/src/styling/theme';
import breakpointsMinWidth from '../../../../cra/src/styling/breakpointsMinWidth';
import { routes } from '../../../utilities/constants';
import { cleanPathname, featurePages } from '../../../constants/navbar';

const LinkWrapper = styled.span`
  color: #333d47;

  white-space: nowrap;
  font-size: 12px;
  ${(props) => {
    const { pathName, isTop } = props;
    if (
      (pathName === '/about-us' ||
        pathName === '/about-us/' ||
        pathName === '/') &&
      isTop
    ) {
      return css`
        color: ${white};
        &:hover {
          // change color on hover here
          color: white !important;
          opacity: 0.8;
        }
      `;
    }

    return css`
      color: #333d47;
    `;
  }}
  &.myDrive, &.invite, &.pricing, &.aboutUs, &.blogGallery,&.learning, &.services, &.veterans, &.higherEducation {
    /* color: ${({ pathName, isTop }) =>
      pathName === '/' && isTop ? '#fff' : smokeGray}; */
    color: ${({ pathName, isTop, appType }) => {
      const isFeaturePage =
        appType !== 'CRA' &&
        featurePages.includes(cleanPathname(pathName)) &&
        pathName !== '/';
      if (pathName === '/' && isTop) {
        return '#fff';
      }
      if (isFeaturePage) {
        return '#fff';
      }
      return smokeGray;
    }};
    font-weight: 400;
    transition: color 0.2s ease-out;
    border-radius: 8px;
    padding: 2px 2px;
    font-size: 14px;

    @media ${breakpointsMinWidth.tabletMd} {
      padding: 2px 4px;
    }
    &:hover {
      color: ${PrimaryMedium};
      ${(props) => {
        const { pathName } = props;
        if (pathName && pathName.includes(routes.DRIVE)) {
          return css`
            color: ${smokeGray};
            background-color: ${translucentGray};
          `;
        }
        return null;
      }}
    }
  }
  a {
    color: inherit;
    text-decoration: none !important;

    &:hover {
      color: inherit;
    }
  }
  @media ${breakpointsMinWidth.desktopMd} {
    font-size: 14px;
  }
`;

export const BetaTag = styled.div`
  display: inherit;
  background: ${PrimaryDark};
  color: ${white};
  padding: 0 4px;
  font-size: 12px;
  border-radius: 4px;
  margin-left: 4px;
`;

export const BETA = 'Beta';

const URL = ({
  listItem,
  pathName,
  isTop,
  inviteId,
  LinkComponent,
  appType,
}) => {
  if (!LinkComponent) return <></>;

  return (
    <LinkWrapper
      aria-label={listItem.ariaLabel}
      className={listItem.className}
      pathName={pathName}
      isTop={isTop}
      onClick={
        listItem.onClick && inviteId
          ? () =>
              listItem.onClick(
                `${window.location.origin}/invite?referrerId=${inviteId}`,
              )
          : () => {}
      }
      appType={appType}
    >
      <LinkComponent
        to={listItem.url}
        onClick={
          listItem.url === '/#invite'
            ? (e) => {
                e.preventDefault();
              }
            : null
        }
      >
        {listItem.text}
        {listItem.beta && (
          <BetaTag id="beta-tag">
            <span>{BETA}</span>
          </BetaTag>
        )}
      </LinkComponent>
    </LinkWrapper>
  );
};

URL.propTypes = {
  listItem: propTypes.shape({
    url: propTypes.string,
  }),
  pathName: propTypes.string,
  isTop: propTypes.bool,
};

URL.defaultProps = {
  listItem: {
    url: '/url',
  },
  pathName: '',
  isTop: false,
};

export default URL;
